import { createReducer, on } from '@ngrx/store';
import { lifeCycleActions } from '../life-cycle/life-cycle.actions';
import { videoUploadsSyncHandlers } from './producers/video-uploads/video-uploads-sync.handlers';
import { initialSyncState } from './sync.state';

// Generic sync slice. Holds SyncAction children keyed by `${type}:${id}`; its state is written by
// each producer's handlers (today: video uploads), composed here.
export const syncReducer = createReducer(
  initialSyncState,
  on(lifeCycleActions.resetState, () => initialSyncState),
  ...videoUploadsSyncHandlers,
);
